import type { HysysVersion, UVAttachment } from '@hysys-uv/shared';

interface Props {
  attachment: UVAttachment;
  version: HysysVersion;
}

export function InstructionsPanel({ attachment, version }: Props): JSX.Element {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs">
        <Badge label="Object" value={attachment.objectType} />
        <Badge label="Return" value={attachment.returnType} />
        <Badge label="Timing" value={attachment.timing} />
        <Badge label="HYSYS" value={version} />
      </div>
      {attachment.units && (
        <div className="text-sm text-neutral-400">
          Units: <code className="text-neutral-200">{attachment.units}</code>
        </div>
      )}
      <ol className="space-y-2">
        {attachment.steps.map((step, i) => (
          <li key={i} className="flex gap-3 text-sm">
            <span className="flex-none w-6 h-6 rounded-full bg-accent/20 text-accent text-xs font-semibold flex items-center justify-center">
              {i + 1}
            </span>
            <span className="text-neutral-200">{step}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}

function Badge({ label, value }: { label: string; value: string }): JSX.Element {
  return (
    <div className="border border-border-subtle rounded-md p-2">
      <div className="text-neutral-500 uppercase tracking-wide">{label}</div>
      <div className="text-neutral-100 text-sm mt-0.5">{value}</div>
    </div>
  );
}
